import { render } from "./AppRichText.vue?vue&type=template&id=241b9572&scoped=true"
import script from "./AppRichText.vue?vue&type=script&lang=js"
export * from "./AppRichText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-241b9572"]])

export default __exports__